import { mergeMap } from 'rxjs';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { AdjustmentProfileAction } from '@cbridge-packages/adjustment-profile';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';

export const closeDetailsSidebarEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(AdjustmentProfileAction.update.done),
  mergeMap(() => {
    return [DetailsSidebarAction.toggleEdit()];
  }),
);
